export const getLoadingGradeStatus = (state) => state.scoreBoard.isLoading;
export const getFilterGradebook = (state) => state.scoreBoard.filter;
export const getGradebook = state => state.scoreBoard.grades;
export const getGradesHeading = (state) => state.scoreBoard.headings;
